import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TabComponent } from '../../../../core/panels/tab-panel/tab.component';
import { TabPanelComponent } from '../../../../core/panels/tab-panel/tab-panel.component';
import { ParticipantDetailComponent } from './participants-detail.component';
import { ParticipantLocationComponent } from './participants-location.component';
import { ParticipantInformationComponent } from './participants-information.component';
import { ParticipantCorrespondenceComponent } from './participants-correspondence.component';

@Component({
  selector: 'app-participants',
  imports: [
    TabComponent,
    TabPanelComponent,
    TableComponent,
    ColumnComponent,
    ParticipantDetailComponent,
    ParticipantLocationComponent,
    ParticipantInformationComponent,
    ParticipantCorrespondenceComponent,
  ],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [expandable]="true"
    dataKey="id"
    recordLabel="Participant"
    [stripedRows]="false"
    [globalFilterFields]="[
      'details.name',
      'details.firstName',
      'details.lastName',
      'details.effectiveDate',
      'details.expireDate',
      'details.description',
    ]"
  >
    <app-column name="details.name" label="Name" width="15%" />
    <app-column name="details.firstName" label="First Name" width="15%" />
    <app-column name="details.lastName" label="Last Name" width="15%" />
    <app-column
      name="details.effectiveDate"
      label="Effective Date"
      width="15%"
      format="d"
    />
    <app-column
      name="details.expireDate"
      label="Expire Date"
      width="15%"
      format="d"
    />
    <app-column name="details.description" label="Description" width="25%" />
    <ng-template #expand let-data>
      <div class="tw-flex tw-gap-8">
        <div class="tw-basis-full">
          <app-tab-panel>
            <app-tab label="Detail">
              <ng-template #content>
                <app-participant-detail [dataSource]="data.details" />
              </ng-template>
            </app-tab>
            <app-tab label="Location">
              <ng-template #content>
                <app-participant-location [dataSource]="data.location" />
              </ng-template>
            </app-tab>
            <app-tab label="Information">
              <ng-template #content>
                <app-participant-information [dataSource]="data.information" />
              </ng-template>
            </app-tab>
            <app-tab
              label="Correspondence"
              [count]="data.correspondence.length"
            >
              <ng-template #content>
                <app-participant-correspondence
                  [dataSource]="data.correspondence"
                />
              </ng-template>
            </app-tab>
          </app-tab-panel>
        </div>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class PolicyParticipantsComponent {
  @Input() dataSource: any;
}
